<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Contáctenos</h2>
                </div>
                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Contáctenos</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="contact-info-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="row">
                    <div class="col-lg-6 col-sm-6 col-md-6">
                        <div class="single-contact-info">
                            <i class="bx bx-envelope"></i>
                            <h3>Correo electrónico:</h3>
                            <a href="mailto:hello&#64;hosta.com">contacto&#64;encloudmx.com</a>
                            <a href="mailto:hello&#64;hosta.com">soporte&#64;encloudmx.com</a>

                            <!-- <a href="mailto:info&#64;hosta.com">info&#64;hosta.com</a> -->
                        </div>
                    </div>

                    <div class="col-lg-6 col-sm-6 col-md-6">
                        <div class="single-contact-info">
                            <i class="bx bx-phone-call"></i>
                            <h3>Llámanos:</h3>
                            <a href="tel:+(52)64413387781">Tel. + (52)64413387781</a>
                            <a href="tel:+(52)64413387782">Tel. + (52)64413387782</a>
                        </div>
                    </div>

                    <div class="col-lg-6 col-sm-6 col-md-6">
                        <div class="single-contact-info">
                            <i class="bx bx-location-plus"></i>
                            <h3>Ciudad Obregón</h3>
                            <a>Guaymas/México 15 S and C. Jalisco MX</a>
                        </div>
                    </div>

                    <div class="col-lg-6 col-sm-6 col-md-6">
                        <div class="single-contact-info">
                            <i class="bx bx-support"></i>
                            <h3>Chat</h3>
                            <a>Conéctate a través de nuestras redes</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div id="map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d158866.35017118193!2d-109.93483299194218!3d27.477504831707627!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86d9b3d107c1b313%3A0x123a5e7a80a560e6!2sCiudad%20Obreg%C3%B3n%2C%20Sonora%2C%20M%C3%A9xico!5e0!3m2!1ses!2smx!4v1600168995687!5m2!1ses!2smx"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>

<app-contact-form [pt]="pt" [pb]="pb" [section]="section"></app-contact-form>
